import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDollarSign, FiMail, FiSmartphone, FiGlobe, FiCheckCircle, FiFacebook } = FiIcons;

const included = [
  { icon: FiMail,      label: 'Ad on the Co-op Mailer',          sub: '2.6″ × 3.75″ · 5,000 homes per drop' },
  { icon: FiCheckCircle, label: '250 Two-Sided Business Cards',   sub: '16pt full color · same design as your mailer ad' },
  { icon: FiSmartphone, label: 'QR Code Setup',                   sub: 'Links directly to your Mailbox Digital landing page' },
  { icon: FiGlobe,     label: 'Landing Page Included (1st run)',  sub: 'Contact form, gallery, services, phone & more' },
];

export default function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-brand-dark text-brand-cream overflow-hidden relative">
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-blue rounded-full blur-[120px]" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        <div className="inline-flex items-center gap-2 bg-brand-blue/20 text-brand-blue px-6 py-2 rounded-full text-sm font-black uppercase tracking-[0.2em] mb-12 border-2 border-brand-blue/30">
          <SafeIcon icon={FiDollarSign} /> Simple, Transparent Pricing
        </div>
        <h2 className="text-5xl md:text-7xl font-black mb-4 uppercase tracking-tighter italic text-white leading-none">
          One Price.<br />Everything Included.
        </h2>
        <p className="text-brand-cream/50 font-bold text-lg max-w-xl mx-auto mb-16">
          No tiers, no surprises. One flat rate gets you on the mailer, in the mailbox, and online.
        </p>

        {/* Main pricing card */}
        <div className="max-w-2xl mx-auto bg-white rounded-[3rem] p-12 md:p-16 text-left border-4 border-brand-blue shadow-[0_0_80px_rgba(0,159,227,0.25)] relative overflow-visible mb-16">
          <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand-yellow text-brand-brown text-xs font-black px-6 py-2 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap">
            Everything You Need · One Run
          </div>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
            <div>
              <div className="text-brand-blue font-black text-6xl md:text-8xl leading-none">$375</div>
              <div className="text-brand-brown/40 font-bold uppercase tracking-widest text-sm mt-2">per slot · 2.6″ × 3.75″ ad</div>
            </div>
            <div className="bg-brand-cream rounded-2xl px-6 py-4 text-center">
              <div className="text-brand-brown font-black text-2xl uppercase tracking-tight">5,000</div>
              <div className="text-brand-brown/50 font-bold text-xs uppercase tracking-widest">homes per drop</div>
            </div>
          </div>

          <div className="space-y-5">
            {included.map((item, i) => (
              <div key={i} className="flex items-start gap-4">
                <div className="w-10 h-10 shrink-0 bg-brand-blue/10 rounded-xl flex items-center justify-center text-brand-blue mt-0.5">
                  <SafeIcon icon={item.icon} />
                </div>
                <div>
                  <p className="font-black text-brand-brown uppercase tracking-tight">{item.label}</p>
                  <p className="text-brand-brown/50 font-bold text-sm">{item.sub}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t-2 border-brand-brown/10">
            <p className="text-brand-brown/40 font-bold text-xs uppercase tracking-widest text-center">
              Category exclusivity guaranteed · Design help included · One advertiser per trade
            </p>
          </div>
        </div>

        <a
          href="https://www.facebook.com/thegyrohero"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-4 bg-brand-yellow text-brand-brown px-16 py-8 rounded-[2.5rem] font-black text-2xl uppercase tracking-tight transition-all hover:scale-105 active:scale-95 shadow-[0_20px_50px_rgba(255,202,8,0.2)]"
        >
          <SafeIcon icon={FiFacebook} className="text-4xl text-brand-blue" />
          Reserve Your Spot
        </a>
      </div>
    </section>
  );
}
